<template>
	<header class="header">
		<div class="container_1200">
			<div class="logo">
				<img src="/static/logo.png" />
			</div>
			<!-- 导航内容 -->
			<ul class="nav">
				<li v-for="(item,index) in navList" :key="index" :class="index==navIndex?'on':''"
					@click="navClick(index,item.name)">
					<router-link :to="item.path">
						<div class="title">
							{{item.name}}
						</div>
					</router-link>
					<div class="second_nav" v-if="item.children.length>0">
						<div class="container_1200">
							<div style="display: flex;flex-wrap: wrap;">
								<div :class="item.children.length =='4'?'res2':'res3'" class="res1"
									v-for="(i,n) in item.children" :key="n"
									:style="{'width':item.children.length =='4'?'20%':'30%'}">
									<router-link :to="i.path">
										<div class="chiTitle">
											{{i.name}}
										</div>
									</router-link>
									<div class="res " v-for="(e,n) in i.children" :key="n">
										<router-link :to="e.path">
											<img :src="e.img" />
											<div class="second_title text_ellipsis_3">
												{{e.name}}
											</div>
										</router-link>
									</div>

								</div>
							</div>
						</div>
					</div>

				</li>
				<li>
					<a href="http://manage.dipeng.vip" target="_blank">
						<div class="title">
							智慧云充电平台
						</div>
					</a>

				</li>
			</ul>
			<div class="eat">
				<img src="static/icon_eat.png" alt="" />
				<div class="fl">
					{{company.phone}}
				</div>
				<div class="clear"></div>
			</div>
			<div class="clear"></div>
		</div>
	</header>

</template>
<script>
	import {
		getToken,
		getWnSysSet
	} from '@/api/user.js'
	export default {
		name: "Header",
		data() {
			return {
				navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
				menuName: "首页",
				menuClass: "glyphicon glyphicon-menu-down",
				company: {},
				navList: [{
						name: "首页",
						path: "/",
						children: []
					},
					{
						name: "产品中心",
						path: "/operate",
						children: [{
								name: '电动车充电桩',
								path: "",
								children: [{
										name: '双路联网充电插座',
										img: '/static/602s.png',
										path: "/operate?id=100"
									}, {
										name: '16A双路联网充电插座',
										img: '/static/602s.png',
										path: "/operate?id=602"
									}, {
										name: "10路智能充电站",
										path: "/operate?id=210",
										img: '/static/210.png'
									},
									{
										name: '12路智能充电站',
										img: '/static/212.png',
										path: "/operate?id=212"
									},

									// {
									//   name: '智能充电插座DP-M602SW-C',
									//   img: '/static/602.png',
									//   path: "/operate/602"
									// },


								]
							},
							{
								name: '电动汽车充电桩',
								path: "",
								children: [{
										name: '交流充电桩',
										img: '/static/710.png',
										path: "/operate?id=710"
									},
									{
										name: '直流快速充电桩',
										img: '/static/z12.png',
										path: "/operate?id=810"
									},
								]
							},
							{
								name: '充电柜/换电柜',
								path: "",
								children: [{
										name: '智能充/换电柜',
										img: '/static/08s.png',
										path: "/operate?id=820"
									},
									// {
									//   name: '换电柜',
									//   img: '/static/08s.png',
									//   path: "/operate/830"
									// },
								]
							},
							{
								name: '智能充电管理平台',
								path: "",
								children: [{
									name: '智能充电管理平台',
									img: '/static/pt.png',
									path: "/operate?id=910"
								}, ]
							}
						],

					},
					{
						name: "案例中心",
						path: "/case_center",
						children: []
					},
					{
						name: "业务合作",
						path: "/business",
						children: [{
							name: '直营业务',
							path: "/business?id=7",
							t: 'INVESTMENT OPERATIONE'
						}, {
							name: '渠道合作',
							path: "/business?id=5",
							t: 'OPERATION COOPERATION'
						}, {
							name: '增值服务',
							path: "/business?id=6",
							t: 'VALUE-ADDED SERVICES'
						}]
					},
					{
						name: "新闻资讯",
						path: "/news",
						children: []
					},
					{
						name: "关于我们",
						path: "/aboutus",
						children: [{
							name: '公司简介',
							path: "/aboutus?id=0",
							t: 'COMPANY PROFILE'
						}, {
							name: '公司历程',
							path: "/aboutus?id=1",
							t: 'COMPANY HISTORY'
						}, {
							name: '公司荣誉',
							path: "/aboutus?id=2",
							t: 'HONORS'
						}, {
							name: '公司资质',
							path: "/aboutus?id=3",
							t: 'COMPANY QUALIFICATION'
						}, {
							name: '联系方式',
							path: "/aboutus?id=4",
							t: 'CONTACT INFORMATION'
						}]
					},
				]
			};
		},
		mounted() {
			this.getWnSysSet()
		},
		methods: {
			getWnSysSet() {
				getWnSysSet().then((res) => {
					localStorage.setItem('company', JSON.stringify(res.result))
					this.company = res.result
				})
			},
			navClick(index, name) {
				this.navIndex = index;
				sessionStorage.setItem('navIndex', index)
				this.menuName = name;
			},

		},

	};
</script>
<style>
	.nav>li>a {
		padding: 0;
		color: #1799fb;
	}

	.nav>li>a:focus,
	.nav>li>a:hover {
		background: inherit;
	}

	a:focus,
	a:hover {
		text-decoration: none;
	}
</style>


// WEBPACK FOOTER //
// src/components/Header.vue